export const legacy = [{
        title: 'origin',
        'desc': 'started in 1993 with its headquarters in Panipat, India with just 600 rotors'
    },
    {
        title: 'growth',
        'desc': 'dedicatedly supplied the finest quality product to emerge as one of the',
        'desc2': 'most eminent names in high performance knitting and weaving yarns'
    },
    {
        title: 'currently',
        'desc': 'exporting more than 2000 containers annually in over 15 countries'
    },
]